// Module
var code = "<div class=\"br-caption-2\" md-colors=\"{ background: $ctrl.backColor || 'black' }\" layout-align=\"center center\" layout=\"column\"> <span>{{$ctrl.status | translate}}</span> </div> ";
// Exports
export default code;